import { useLanguageContext } from "../context/LanguageContext";

const useLanguage = () => useLanguageContext();

export default useLanguage;
